<div pFocusTrap class="confirmation flex flex-col items-center">
  <picture class="confirmation-icon-circle">
    <i class="icon-warning color-white"></i>
  </picture>
  <div class="confirmation__content flex justify-center items-center flex-col">
    <h5>
      {{ title | translate }}
    </h5>
    <p
      class="text-muted mb-0 text-center"
      *ngIf="!hideMessage && isGeneralMessage"
    >
      {{ message | translate }}
    </p>

    <p
      class="text-muted mb-0 text-center"
      *ngIf="!hideMessage && !!customMessageTranslated"
    >
      {{ customMessageTranslated }}
    </p>

    <div class="my-8 flex justify-between">
      <p-button
        type="button"
        styleClass="p-button-plain px-12 btn-bg font-normal uppercase"
        (onClick)="close(false)"
        [label]="cancelButton | translate"
        tabindex="-1"
      ></p-button>
      &nbsp; &nbsp;
      <p-button
        type="button"
        (onClick)="close(true)"
        styleClass="px-12 uppercase"
        [label]="confirmButton | translate"
        [pAutoFocus]="true"
        [autofocus]="true"
      >
      </p-button>
    </div>
  </div>
</div>
